import React from 'react';
import { Link } from 'react-router-dom';
import './header.scss';

function HeaderNav(props: any) {
  return (
    <header className='header'>
      <Link to='/' className='logo'>
        <i className='icn-logo'></i>
        <span className='text'>Effy Yin</span>
      </Link>
      <Link to='#' className='btn-menu' onClick={props.onClick}>
        <span className='menu-icon'>
          <i className='icn-close'></i>
          <i className='icn-menu'></i>
        </span>
        <span className='text'>
          <span className='text-default'>MENU</span>
          <span className='text-open'>CLOSE</span>
        </span>
      </Link>
    </header>
  );
}

export default HeaderNav;
